/// <reference path="../../app.typings.d.ts" />
'use strict';
var app;
(function (app) {
    var Services;
    (function (Services) {
        var HelperService = /** @class */ (function () {
            function HelperService() {
                // Everything that was in this service was deprecated by the meta update,
                // So I emptied it
            }
            HelperService.$inject = [
                '$q',
                'applicationApiService',
                'locationService'
            ];
            return HelperService;
        }());
        Services.HelperService = HelperService;
        angular.module('app.Services')
            .service('helperService', HelperService);
    })(Services = app.Services || (app.Services = {}));
})(app || (app = {}));
